import { graphql } from "./generated/gql";

export const InterviewersQuery = graphql(`
  query Interviewers {
    interviewers {
      nodes {
        interviewerId
        email
        name
        isAdmin
        isDefault
        isKeyInterviewer
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`);

export const InterviewerQuery = graphql(`
  query Interviewer($interviewerId: ID!) {
    interviewer(interviewerId: $interviewerId) {
      interviewerId
      email
      name
      isAdmin
      isDefault
      isKeyInterviewer
      createdAt
      updatedAt
    }
  }
`);

export const TermInterviewersQuery = graphql(`
  query TermInterviewers($termId: ID!) {
    termInterviewers(termId: $termId) {
      nodes {
        interviewerId
        email
        name
        isAdmin
        isDefault
        isKeyInterviewer
        linkedGoogleAccountCount
        assignedInterviewCount
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`);

export const CreateInterviewerMutation = graphql(`
  mutation CreateInterviewer($input: CreateInterviewerInput!) {
    createInterviewer(input: $input) {
      interviewerId
      email
      name
      isAdmin
      isDefault
      isKeyInterviewer
      createdAt
      updatedAt
    }
  }
`);

export const UpdateInterviewerMutation = graphql(`
  mutation UpdateInterviewer($input: UpdateInterviewerInput!) {
    updateInterviewer(input: $input) {
      interviewerId
      email
      name
      isAdmin
      isDefault
      isKeyInterviewer
      createdAt
      updatedAt
    }
  }
`);

export const DeleteInterviewerMutation = graphql(`
  mutation DeleteInterviewer($interviewerId: ID!) {
    deleteInterviewer(interviewerId: $interviewerId) {
      __typename
      ... on DeleteInterviewerSuccess {
        interviewerId
      }
      ... on DeleteInterviewerHasUpcomingScheduledInterviewsError {
        upcomingCount
        message
      }
      ... on DeleteInterviewerHasRelatedInterviewsError {
        relatedCount
        message
      }
    }
  }
`);

export const AssignInterviewerToTermMutation = graphql(`
  mutation AssignInterviewerToTerm($termId: ID!, $interviewerId: ID!) {
    assignInterviewerToTerm(termId: $termId, interviewerId: $interviewerId) {
      success
      termId
      interviewerId
      errorMessage
    }
  }
`);

export const RemoveInterviewerFromTermMutation = graphql(`
  mutation RemoveInterviewerFromTerm($termId: ID!, $interviewerId: ID!) {
    removeInterviewerFromTerm(termId: $termId, interviewerId: $interviewerId) {
      success
      termId
      interviewerId
      errorMessage
    }
  }
`);
